export default __webpack_public_path__ + "static/media/exclusive-badge.69635475.png";